<template>
  <a-tooltip overlayClassName="tooltip-wrapper" :style="{ width: `${width}px` }">
    <template slot="title">
      <slot name="title"></slot>
    </template>
    <slot></slot>
  </a-tooltip>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    text: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 450,
    },
  },
};
</script>

<style lang="scss">
.tooltip-wrapper {
  width: 450px;
  max-width: 450px;
  .ant-tooltip-inner {
    background-color: #fff;
    color: #000;
    padding: 20px;
  }
}
</style>
